import { Button, Card, Space, Form, Input } from "antd";
import React, { useEffect, useState } from "react";
import { API_METHODS, BLANK_VALUE } from "../../../constants";
import useApi from "../../../hooks/useApi";
import TableComponent from "../../common/TableComponent";
import { EditOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { useMediaQuery } from "react-responsive";

function CustomerTable() {
  const isMobile = useMediaQuery({ maxWidth: 950 });
  let columns = [
    {
      title: "First Name",
      dataIndex: "first_name",
    },
    {
      title: "Last Name",
      dataIndex: "last_name",
      isMobile: isMobile,
    },
    {
      title: "Organisation",
      dataIndex: "organisation",
      isMobile: isMobile,
    },
    {
      title: "Primary Mail",
      dataIndex: "primary_mail",
      isMobile: isMobile,
    },
    {
      title: "Primary Phone",
      dataIndex: "primary_phone",
      isMobile: isMobile,
    },
    {
      title: "Assigned To",
      dataIndex: "assigned_to_username",
    },
    {
      title: "Action",
      key: "action",
      render: (text, record) => (
        <>
          <Space>
            <Button size="small" onClick={() => editRecord(record)}>
              <EditOutlined />
            </Button>
          </Space>
        </>
      ),
    },
  ];

  if (isMobile) {
    columns = columns.filter((c) => !c.isMobile);
  }

  const [responseData, getRequest] = useApi(
    `/config/customer?pageNumber=${1}`,
    null,
    API_METHODS.GET
  );

  const [tableData, setTableData] = useState();

  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const navigate = useNavigate();
  const [searchVisible, setSearchVisible] = useState(false);
  const [form] = Form.useForm();

  useEffect(() => {
    getRequest();
  }, []);

  useEffect(() => {
    const data = responseData.data !== BLANK_VALUE ? responseData.data : [];
    const pagination =
      responseData.pagination !== BLANK_VALUE ? responseData.pagination : {};
    setTableData(data);
    setTotalRecords(pagination ? pagination.count : 0);
  }, [responseData]);

  const editRecord = (record) => {
    navigate("/portal/setting/customer/add", {
      state: record,
    });
  };

  const onPaginationChange = (page) => {
    const values = form.getFieldsValue();
    let url = `/config/customer?pageNumber=${page.current}`;

    if (values.search) {
      url += `&search=${encodeURIComponent(values.search)}`;
    }

    getRequest(null, API_METHODS.GET, url);
    setCurrentPage(page.current);
  };

  const handleSearch = () => {
    const values = form.getFieldsValue();
    setCurrentPage(1);
    let url = `/config/customer?pageNumber=1`;

    if (values.search) {
      url += `&search=${encodeURIComponent(values.search)}`;
    }

    getRequest(null, API_METHODS.GET, url);
  };

  const handleReset = () => {
    form.resetFields();
    setCurrentPage(1);
    getRequest(null, API_METHODS.GET, `/config/customer?pageNumber=1`);
  };

  return (
    <Card
      title="Customers"
      extra={
        <>
          <Button
            onClick={() => setSearchVisible(!searchVisible)}
            style={{ marginRight: 8 }}
          >
            {searchVisible ? "Hide Search" : "Search"}
          </Button>
          <Button
            type="primary"
            onClick={() => {
              navigate("/portal/setting/customer/add");
            }}
          >
            Add Customer
          </Button>
        </>
      }
    >
      {searchVisible && (
        <div
          style={{
            padding: "16px",
            background: "#f5f5f5",
            marginBottom: "16px",
            borderRadius: "6px",
          }}
        >
          <Form form={form} layout="inline">
            <Form.Item name="search" label="Search">
              <Input
                placeholder="Search by name or organisation"
                style={{ width: 250 }}
              />
            </Form.Item>
            <Form.Item>
              <Button type="primary" onClick={handleSearch}>
                Search
              </Button>
              <Button onClick={handleReset} style={{ marginLeft: 8 }}>
                Reset
              </Button>
            </Form.Item>
          </Form>
        </div>
      )}
      <TableComponent
        columns={columns}
        tableData={tableData}
        loading={responseData.isLoading}
        onPaginationChange={onPaginationChange}
        total={totalRecords}
        current={currentPage}
      />
    </Card>
  );
}

export default CustomerTable;
